import { IConstantAuthVT } from "./types/constant";

export const MODULE_MAP: IConstantAuthVT = {
  DAYU_MARKET: {
    value: 'DAYU_MARKET',
    text: '大禹投放中心',
  },
  DAYU_MATERIAL: {
    value: 'DAYU_MATERIAL',
    text: '素材管理中心',
    path: 'app/material/material-center',
  },
  DAYU_MATERIAL_DEMAND: {
    value: 'DAYU_MATERIAL_DEMAND',
    text: '素材需求中心（需求方）',
    path: 'app/demand/demand-center',
  },
  DAYU_MATERIAL_SUPPLIER: {
    value: 'DAYU_MATERIAL_SUPPLIER',
    text: '素材需求中心（服务商）',
    path: 'app/supplier/supplier-center',
  },
  DAYU_GAME: {
    value: 'DAYU_GAME',
    text: '小游戏投放',
    path: 'app/game/advertising',
  },
};
